import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { withRouter, useParams } from "react-router-dom";
import { connect } from "react-redux";
/* import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import EditorUploadAdapterPlugin from "../../../plugins/ckeditor/UploadAdapterPlugin" */
import CKEditor from "react-ckeditor-component";
import FormButton from "components/Common/FormButtons";

import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Form,
  FormGroup,
  Label,
  Input,
  Alert,
  Spinner,
  Button,
} from "reactstrap";

import { addFaq, getFaq, putFaq } from "store/actions";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb2";

//i18n
import { withTranslation } from "react-i18next";
import Welcomegreet from "components/Welcomegreet";

const AddCustomer = ({
  accessLevel,
  history,
  error,
  onAddFaq,
  onGetFaq,
  onPutFaq,
  faq,
  loading,
  ...props
}) => {
  const { id } = useParams();
  const didMountRef = useRef(null);

  const [submitInfo, setSubmitInfo] = useState(null);
  const [accesses, setaccesses] = useState({
    canAdd: false,
    canEdit: false,
  });
  const [fields, setFields] = useState({
    question: "",
    answer: "",
    status: "active",
  });

  useEffect(() => {
    if (!accessLevel) {
      const data = {
        canAdd: true,
        canEdit: true,
      };

      return setaccesses(data);
    }

    const data = {
      canAdd: false,
      canEdit: false,
    };

    accessLevel?.map((item) => {
      switch (item.label) {
        case "CREATE":
          data.canAdd = item.value;
          break;

        case "UPDATE":
          data.canEdit = item.value;
          break;
      }
    });

    setaccesses(data);
  }, [JSON.stringify(accessLevel)]);

  useEffect(() => {
    if (id) {
      onGetFaq(id);
    }
  }, [id]);

  useEffect(() => {
    if (didMountRef.current) {
      if (!!faq && !!faq.answer) {
        try {
          setFields({
            question: faq.question || "",
            answer: faq.answer || "",
            status: faq.status || "active",
          });
        } catch (err) {
          console.log("parsing error ", err);
        }
      }
    } else didMountRef.current = true;
  }, [JSON.stringify(faq)]);

  const handleChange = (name) => (event) => {
    setFields((prevState) => ({ ...prevState, [name]: event.target.value }));
  };

  const onSubmit = (event) => {
    event.preventDefault();

    if (loading) return;

    if (id) {
      if (!accesses.canEdit) return;
      try {
        onPutFaq({ _id: faq._id, ...fields }, history);
        setSubmitInfo("Edit  successfully!!");
      } catch {
        setSubmitInfo(" Some Error Occurred !!");
      }
    } else {
      try {
        if (!accesses.canAdd) return;
        onAddFaq({ ...fields }, history);
        setSubmitInfo("Added successfully!!");
      } catch {
        setSubmitInfo(" Some Error Occurred !!");
      }
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
        <Row>
            <Col lg={12}>
               <Welcomegreet />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col lg={12}>
                  <Form onSubmit={onSubmit} className="spinner-content">
                    <Row>
                      <Col md={12}>
                        <FormGroup>
                          <Label for="formrow-firstname-Input">
                            {props.t("question")}
                          </Label>
                          <Input
                            type="text"
                            id="formrow-firstname-Input"
                            value={fields.question}
                            onChange={handleChange("question")}
                            required
                          />
                        </FormGroup>
                      </Col>

                      <Col md={12}>
                        <FormGroup>
                          <Label>{props.t("answer")}</Label>

                          <CKEditor
                            content={fields.answer}
                            events={{
                              change: (evt) => {
                                const data = evt?.editor?.getData();

                                handleChange("answer")({
                                  target: { value: data },
                                });
                              },
                            }}
                            config={{
                              height: 250,
                              toolbar: [
                                [
                                  "Undo",
                                  "Redo",
                                  "Font",
                                  "FontSize",
                                  "Styles",
                                  "Format",
                                  "-",
                                  "Maximize",
                                  "-",
                                  "Source",
                                ],
                                [
                                  "Bold",
                                  "Italic",
                                  "Underline",
                                  "Strike",
                                  "-",
                                  "RemoveFormat",
                                  "-",
                                  "NumberedList",
                                  "BulletedList",
                                ],
                                [
                                  "Link",
                                  "Unlink",
                                  "-",
                                  "JustifyLeft",
                                  "JustifyCenter",
                                  "JustifyRight",
                                  "JustifyBlock",
                                  "-",
                                  "Outdent",
                                  "Indent",
                                  "-",
                                  "TextColor",
                                  "BGColor",
                                ],
                                [
                                  "Image",
                                  "Table",
                                  "HorizontalRule",
                                  "SpecialChar",
                                  "-",
                                  "Blockquote",
                                ],
                              ],
                            }}
                            scriptUrl="https://cdn.ckeditor.com/4.16.0/full/ckeditor.js"
                          />

                          {/* <CKEditor
                            editor={ClassicEditor}
                            data={fields.answer}
                            config={{
                              extraPlugins: [EditorUploadAdapterPlugin],
                            }}
                            onChange={(event, editor) => {
                              const data = editor.getData()

                              handleChange("answer")({
                                target: { value: data },
                              })
                            }}
                          /> */}
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label>{props.t("status")}</Label>

                          <div className="status-switch square-switch">
                            <input
                              type="checkbox"
                              id="square-switch1"
                              switch="none"
                              checked={fields.status == "active"}
                              onChange={() => {
                                const value =
                                  fields.status == "active"
                                    ? "inactive"
                                    : "active";

                                handleChange("status")({ target: { value } });
                              }}
                            />
                            <label
                              htmlFor="square-switch1"
                              data-on-label={props.t("active")}
                              data-off-label={props.t("inactive")}
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>

                    <Button className="btn btn-success" type="submit">{id ? props.t("update") : props.t("save")}</Button>

                    {loading && (
                      <div className="spinner">
                        <Spinner color="primary" />
                      </div>
                    )}
                  </Form>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

AddCustomer.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.string,
  faq: PropTypes.object,
  onAddFaq: PropTypes.func,
  onGetFaq: PropTypes.func,
  onPutFaq: PropTypes.func,
};

const mapStateToProps = ({ faqs }) => ({
  error: faqs.error,
  loading: faqs.loading,
  faq: faqs.faq,
});

const mapDispatchToProps = (dispatch) => ({
  onAddFaq: (data, history) => dispatch(addFaq(data, history)),
  onGetFaq: (id) => dispatch(getFaq(id)),
  onPutFaq: (data, history) => dispatch(putFaq(data, history)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AddCustomer))
);
